import { ConfirmButtonGroup } from '@healthhub/react-ui';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import parseHtml from 'html-react-parser';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface NewPatientPromptModalProps {
  isCancelButtonDisabled?: boolean;
  isLiveChatEnabled?: boolean;
  isOkButtonLoading?: boolean;
  onClickCancel: () => void;
  onClickOk: () => void;
}

const NewPatientPromptModal = ({
  isCancelButtonDisabled,
  isOkButtonLoading,
  isLiveChatEnabled,
  onClickCancel,
  onClickOk,
}: NewPatientPromptModalProps) => {
  const { t } = useTranslation('appointments');

  return (
    <div className="flex flex-col gap-2 text-center">
      <Text className="text-center text-base font-bold">{t('appointment.newPatientForAppointment.promptTitle')}</Text>
      <p>{parseHtml(DOMPurify.sanitize(t('appointment.newPatientForAppointment.promptDescription')))}</p>

      <ConfirmButtonGroup
        cancelDisabled={isCancelButtonDisabled}
        cancelText={
          isLiveChatEnabled
            ? t('appointment.newPatientForAppointment.promptLiveChatText')
            : t('appointment.newPatientForAppointment.promptCancelText')
        }
        handleCancel={onClickCancel}
        handleSubmit={onClickOk}
        isLoading={isOkButtonLoading}
        okText={t('appointment.newPatientForAppointment.promptOkText')}
      />
    </div>
  );
};

export default NewPatientPromptModal;
